// Default Data for 5 Core Sections + Profiles

export const defaultData = {
  books: [
    {
      id: "b1",
      title: "The Alchemist",
      titleKurdish: "کیمیاگەر",
      author: "Paulo Coelho",
      category: "ڕۆمان و فەلسەفە",
      cover: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?auto=format&fit=crop&w=600&q=80",
      year: "1988",
      pages: "208",
      rating: 4.8,
      language: "کوردی / ئینگلیزی",
      description: "ڕۆمانی بەناوبانگی کیمیاگەر دەربارەی گەشتی شوانێکی ئەندەلوسییە بە ناوی سانتیاگۆ بەرەو هەرەمەکانی میسر بە دوای گەنجینەیەکدا...",
      downloadUrl: "https://example.com/books/alchemist.pdf"
    },
    {
      id: "b2",
      title: "Atomic Habits",
      titleKurdish: "خووە ئەتۆمییەکان",
      author: "James Clear",
      category: "گەشەپێدانی مرۆیی",
      cover: "https://images.unsplash.com/photo-1589829085413-56de8ae18c73?auto=format&fit=crop&w=600&q=80",
      year: "2018",
      pages: "320",
      rating: 4.9,
      language: "کوردی / ئینگلیزی",
      description: "ڕێگەیەکی ئاسان و سەلمێنراو بۆ بنیادنانی خووی باش و شکاندنی خووی خراپ. چۆن گۆڕانکارییە بچووکەکان ئەنجامی گەورە دروست دەکەن.",
      downloadUrl: "https://example.com/books/atomic-habits.pdf"
    },
    {
      id: "b3",
      title: "Clean Code",
      titleKurdish: "کۆدی خاوێن",
      author: "Robert C. Martin",
      category: "تەکنەلۆژیا و پرۆگرامین",
      cover: "https://images.unsplash.com/photo-1532012164546-f432f2e3777f?auto=format&fit=crop&w=600&q=80",
      year: "2008",
      pages: "464",
      rating: 4.7,
      language: "ئینگلیزی",
      description: "دەستپێک و ڕێساکانی نووسینی نەرمەکاڵای پاک و بێ کێشە، پێویست بۆ هەموو پەرەپێدەرێکی بەرنامەسازی.",
      downloadUrl: "https://example.com/books/clean-code.pdf"
    },
    {
      id: "b4",
      title: "Sapiens: A Brief History of Humankind",
      titleKurdish: "مرۆڤی ژیر: مێژوویەکی کورتی مرۆڤایەتی",
      author: "Yuval Noah Harari",
      category: "مێژوو و زانست",
      cover: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=600&q=80",
      year: "2014",
      pages: "443",
      rating: 4.9,
      language: "کوردی / عەرەبی / ئینگلیزی",
      description: "چۆن جۆرێکی بێ بایەخی مەیموون بوو بە فەرمانڕەوای هەسارەی زەوی؟ گەشتێکی ناوازە بەناو مێژووی زیندەگی و شارستانیەتی مرۆڤدا.",
      downloadUrl: "https://example.com/books/sapiens.pdf"
    },
    {
      id: "b5",
      title: "1984",
      titleKurdish: "١٩٨٤",
      author: "George Orwell",
      category: "ڕۆمانی سیاسی",
      cover: "https://images.unsplash.com/photo-1543002588-bfa74002ed7e?auto=format&fit=crop&w=600&q=80",
      year: "1949",
      pages: "328",
      rating: 4.8,
      language: "کوردی",
      description: "ڕۆمانێکی شاکار دەربارەی کۆمەڵگەیەکی دیکتاتۆری کە برا گەورە تێیدا چاودێری هەموو جموجۆڵ و بیرکردنەوەیەکی هاوڵاتیان دەکات.",
      downloadUrl: "https://example.com/books/1984.pdf"
    },
    {
      id: "b6",
      title: "Deep Work",
      titleKurdish: "کاری قووڵ",
      author: "Cal Newport",
      category: "گەشەپێدانی مرۆیی",
      cover: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
      year: "2016",
      pages: "304",
      rating: 4.6,
      language: "ئینگلیزی",
      description: "یاساکانی سەرکەوتن لە جیهانێکی پڕ لە سەرقاڵکەر و چۆنیەتی سەرنج خستنەسەر کاری گرنگ بە بێ بەفیڕۆدانی کات.",
      downloadUrl: "https://example.com/books/deep-work.pdf"
    }
  ],

  films: [
    {
      id: "f1",
      title: "Interstellar",
      titleKurdish: "ئینتەرستێلار (نێوان ئەستێرەکان)",
      type: "movie",
      genre: "خەیاڵی زانستی، دراما، سەرکێشی",
      poster: "https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=600&q=80",
      year: "2014",
      rating: 8.7,
      duration: "2h 49m",
      quality: "4K UHD",
      description: "تیمێک لە گەڕیدەوان بەناو کونی کرمیدا گەشت دەکەن بە ئامانجی دۆزینەوەی هەسارەیەکی نوێ بۆ مانەوەی نەوەی مرۆڤ.",
      watchUrl: "https://www.youtube.com/watch?v=zSWdZVtXT7E"
    },
    {
      id: "f2",
      title: "Attack on Titan",
      titleKurdish: "پەلاماری زەبەلاحەکان (Shingeki no Kyojin)",
      type: "anime",
      genre: "ئەکشن، دراما، فەنتازیا",
      poster: "https://images.unsplash.com/photo-1578632767115-351597cf2477?auto=format&fit=crop&w=600&q=80",
      year: "2013-2023",
      rating: 9.1,
      duration: "4 وەرز (89 ئەڵقە)",
      quality: "1080p FHD",
      description: "دوای ئەوەی شارۆچکەکەی لەناودەچێت و دایکی دەکوژرێت، ئێلین یێگەر سوێند دەخوات کە زەوی لە هەموو زەبەلاحەکان پاک بکاتەوە.",
      watchUrl: "https://www.youtube.com/watch?v=MGRm4IzK1SQ"
    },
    {
      id: "f3",
      title: "Spider-Man: Across the Spider-Verse",
      titleKurdish: "سپایدەرمان: بەناو گەردوونی جاڵجاڵۆکەدا",
      type: "cartoon",
      genre: "ئەنیمەیشن، ئەکشن، سەرکێشی",
      poster: "https://images.unsplash.com/photo-1635805737707-575885ab0820?auto=format&fit=crop&w=600&q=80",
      year: "2023",
      rating: 8.8,
      duration: "2h 20m",
      quality: "4K HDR",
      description: "مایڵز مۆرالێس بەناو فرەگەردووندا دەگەڕێت و لەگەڵ کۆمەڵێک پاڵەوانی جاڵجاڵۆکەدا بەرەوڕووی هەڕەشەیەکی گەورە دەبێتەوە.",
      watchUrl: "https://www.youtube.com/watch?v=cqGjhVJWtEg"
    },
    {
      id: "f4",
      title: "Spirited Away",
      titleKurdish: "ڕفێندراوی ڕۆحەکان (Sen to Chihiro)",
      type: "anime",
      genre: "فەنتازیا، سەرکێشی، خێزانی",
      poster: "https://images.unsplash.com/photo-1563089145-599997674d42?auto=format&fit=crop&w=600&q=80",
      year: "2001",
      rating: 8.6,
      duration: "2h 05m",
      quality: "1080p BluRay",
      description: "شاکاری ستۆدیۆ جیبلی؛ کچێکی گەنج دەچێتە ناو جیهانێکی نهێنی و پڕ لە ڕۆحەوە دوای ئەوەی دایک و باوکی دەگۆڕدرێن بۆ بەراز.",
      watchUrl: "https://www.youtube.com/watch?v=ByXuk9QqQkk"
    },
    {
      id: "f5",
      title: "The Dark Knight",
      titleKurdish: "سوورچاکە تاریکەکە",
      type: "movie",
      genre: "ئەکشن، تاوان، دراما",
      poster: "https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=600&q=80",
      year: "2008",
      rating: 9.0,
      duration: "2h 32m",
      quality: "4K UHD",
      description: "کاتێک هەڕەشەیەک بە ناوی جۆکەر شاری گۆسام دەخاتە ناو شێواوی و پشێوییەوە، باتمان دەبێت بەرگەی گەورەترین تاقیکردنەوەی دەروونی و جەستەیی بگرێت.",
      watchUrl: "https://www.youtube.com/watch?v=EXeTwQWrcwY"
    },
    {
      id: "f6",
      title: "The Lion King",
      titleKurdish: "شێری پاشا",
      type: "cartoon",
      genre: "ئەنیمەیشن، دراما، سەرکێشی",
      poster: "https://images.unsplash.com/photo-1534188753412-3e26d0d618d6?auto=format&fit=crop&w=600&q=80",
      year: "1994",
      rating: 8.5,
      duration: "1h 28m",
      quality: "1080p FHD",
      description: "سیمبا، شێرە بچووکەکە، دوای لەدەستدانی باوکی دەبێت گەورە بێت و بگەڕێتەوە بۆ سەلماندنی پێگەی شایستەی خۆی وەک پاشای شانشینەکە.",
      watchUrl: "https://www.youtube.com/watch?v=lFzVJEksoDY"
    },
    {
      id: "f7",
      title: "Breaking Bad",
      titleKurdish: "بریکینگ باد (تێکچوونی پڕ لە تاوان)",
      type: "series",
      genre: "تاوان، دراما، هەستبزوێن",
      poster: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=600&q=80",
      year: "2008-2013",
      rating: 9.5,
      duration: "5 وەرز (62 ئەڵقە)",
      quality: "4K UHD",
      description: "مامۆستایەکی کیمیا کە تووشی شێرپەنجە بووە، بۆ دابینکردنی داهاتووی دارایی خێزانەکەی دەست دەکات بە دروستکردنی مادەی هۆشبەر.",
      watchUrl: "https://www.youtube.com/watch?v=HhesaQXLuRY"
    }
  ],

  games: [
    {
      id: "g1",
      title: "Cyberpunk 2077: Phantom Liberty",
      titleKurdish: "سایبەرپانک ٢٠٧٧",
      platform: "PC, PS5, Xbox Series X",
      genre: "RPG، ئۆپن وۆرڵد، ئەکشن",
      banner: "https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=80",
      rating: 4.8,
      releaseYear: "2023",
      fileSize: "70 GB",
      developer: "CD PROJEKT RED",
      description: "شارێکی داهاتوویی پڕ لە شەڕ و تەکنەلۆژیا و گۆڕانکاری جەستەیی. وەک بەکرێگیراوێکی سەرشەقام لە نایت سیتی بژی.",
      downloadUrl: "https://store.steampowered.com/app/1091500"
    },
    {
      id: "g2",
      title: "Elden Ring",
      titleKurdish: "ئێڵدن ڕینگ",
      platform: "PC, PS5, PS4, Xbox",
      genre: "سۆڵزبۆرن، فەنتازیا، RPG",
      banner: "https://images.unsplash.com/photo-1538481199705-c710c4e965fc?auto=format&fit=crop&w=800&q=80",
      rating: 4.9,
      releaseYear: "2022",
      fileSize: "60 GB",
      developer: "FromSoftware",
      description: "شاکاری فرۆم سۆفتوێر بە هاوکاری جۆرج ئاڕ ئاڕ ماڕتن، یەکێک لە باشترین یارییە ئۆپن وۆردە مێژووییەکان.",
      downloadUrl: "https://store.steampowered.com/app/1245620"
    },
    {
      id: "g3",
      title: "God of War Ragnarök",
      titleKurdish: "خوداوەندی جەنگ: ڕاگنارۆک",
      platform: "PS5, PS4, PC",
      genre: "ئەکشن، سەرکێشی، ئەفسانەیی",
      banner: "https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=800&q=80",
      rating: 4.9,
      releaseYear: "2022",
      fileSize: "84 GB",
      developer: "Santa Monica Studio",
      description: "کرەیتۆس و کوڕەکەی ئەتریۆس بەرەو هەر نۆ جیهانە ئەفسانەییە نەرویجییەکان گەشت دەکەن لە پێناو ئامادەکاری بۆ ڕاگنارۆک.",
      downloadUrl: "https://store.playstation.com"
    },
    {
      id: "g4",
      title: "PUBG Mobile",
      titleKurdish: "پەبجی مۆبایل",
      platform: "Android, iOS",
      genre: "باتڵ ڕۆیاڵ، مۆبایل",
      banner: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=800&q=80",
      rating: 4.5,
      releaseYear: "2018",
      fileSize: "1.8 GB",
      developer: "Krafton / Tencent",
      description: "بەناوبانگترین یاری باتڵ ڕۆیاڵ لەسەر مۆبایل، کە ١٠٠ یاریزان بۆ مانەوە دەجەنگن تا تەنها یەک تیم یان کەس سەربکەوێت.",
      downloadUrl: "https://play.google.com/store/apps/details?id=com.tencent.ig"
    },
    {
      id: "g5",
      title: "Red Dead Redemption 2",
      titleKurdish: "ڕێد دێد ڕیدێمپشن ٢",
      platform: "PC, PS4, Xbox One",
      genre: "ئۆپن وۆرڵد، ڕۆژئاوایی، چیرۆک",
      banner: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=800&q=80",
      rating: 5.0,
      releaseYear: "2018",
      fileSize: "120 GB",
      developer: "Rockstar Games",
      description: "چیرۆکی ناوازەی ئارسەر مۆرگان و تاقمی ڤان دەر لیند لە کۆتاییەکانی سەردەمی کێوی ئەمریکادا بە گرافیک و وردەکاری بێوێنە.",
      downloadUrl: "https://store.steampowered.com/app/1172470"
    }
  ],

  apps: [
    {
      id: "a1",
      title: "Visual Studio Code",
      titleKurdish: "ڤیژوەڵ ستۆدیۆ کۆد",
      category: "بەرنامەسازی و کۆدینگ",
      os: "Windows, macOS, Linux",
      icon: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=200&q=80",
      version: "v1.92.0",
      size: "95 MB",
      developer: "Microsoft",
      description: "بەهێزترین و خۆشەویستترین دەستکاریکەری کۆد لە جیهاندا، بە هەزاران ئیستێنشنی خۆڕایی بۆ هەموو زمانەکانی پرۆگرامین.",
      downloadUrl: "https://code.visualstudio.com"
    },
    {
      id: "a2",
      title: "Adobe Photoshop 2024",
      titleKurdish: "ئەدۆبی فۆتۆشۆپ",
      category: "دیزاین و گرافیک",
      os: "Windows, macOS",
      icon: "https://images.unsplash.com/photo-1626785774573-4b799315345d?auto=format&fit=crop&w=200&q=80",
      version: "v25.5",
      size: "3.2 GB",
      developer: "Adobe",
      description: "ستانداردی پیشەیی بۆ دەستکاریکردنی وێنە، دروستکردنی گرافیکی ڕیکلامی و بەکارهێنانی زیرەکی دەستکردی Firefly.",
      downloadUrl: "https://adobe.com/products/photoshop"
    },
    {
      id: "a3",
      title: "Telegram Desktop",
      titleKurdish: "تێلیگرام بۆ کۆمپیوتەر",
      category: "پەیوەندی و گفتوگۆ",
      os: "Windows, macOS, Linux, Mobile",
      icon: "https://images.unsplash.com/photo-1614680376593-902f749f7ffc?auto=format&fit=crop&w=200&q=80",
      version: "v5.4.1",
      size: "45 MB",
      developer: "Telegram FZ-LLC",
      description: "خێراترین و پارێزراوترین بەرنامەی نامەگۆڕینەوە بە پشتگیری ناردنی فایلی گەورە تا ٢ گێگابایت و کەناڵی بێسنوور.",
      downloadUrl: "https://desktop.telegram.org"
    },
    {
      id: "a4",
      title: "OBS Studio",
      titleKurdish: "ئۆ بی ئێس ستۆدیۆ",
      category: "میدیا و لایڤ ستریم",
      os: "Windows, macOS, Linux",
      icon: "https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=200&q=80",
      version: "v30.2",
      size: "128 MB",
      developer: "OBS Project",
      description: "نەرمەکاڵای سەرچاوەکراوەی بێ بەرامبەر بۆ تۆمارکردنی شاشەی کۆمپیوتەر و پەخشی ڕاستەوخۆ (لایڤ ستریم) لە یوتیوب و فەیسبووک.",
      downloadUrl: "https://obsproject.com"
    },
    {
      id: "a5",
      title: "CapCut Pro PC",
      titleKurdish: "کاپ کەت پرۆ",
      category: "مۆنتاژ و ڤیدیۆ",
      os: "Windows, macOS, Mobile",
      icon: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?auto=format&fit=crop&w=200&q=80",
      version: "v3.9.0",
      size: "540 MB",
      developer: "Bytedance",
      description: "بەرنامەیەکی زۆر بەهێز و ئاسان بۆ مۆنتاژکردنی ڤیدیۆی تیکتۆک، ڕیڵز و یوتیوب بە تایبەتمەندی زیرەکی دەستکرد و سەبتایتڵی ئۆتۆماتیکی.",
      downloadUrl: "https://capcut.com"
    }
  ],

  about: {
    title: "دەربارەی بەڕێوەبەران و خاوەنانی پڕۆژە",
    subtitle: "پلاتفۆرمی هاوبەشی ئێمە بۆ پێشکەشکردنی باشترین خزمەتگوزاری دیجیتاڵی کوردی",
    persons: [
      {
        id: "p1",
        name: "کاک ئەحمەد (Ahmed)",
        role: "دامەزرێنەر و سەرپەرشتیار (Founder & Lead Admin)",
        avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=600&q=80",
        banner: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?auto=format&fit=crop&w=800&q=80",
        bio: "سڵاو و ڕێز، من هاودامەزرێنەری ئەم پلاتفۆرمەم. ئارەزووی سەرەکیم تەکنەلۆژیا و دەوڵەمەندکردنی کتێبخانە و سەرچاوە دەگمەنەکانە بۆ لاوانی کوردستان بە شێوازێکی هاوچەرخ.",
        skills: ["Web Development", "UI/UX Design", "Content Strategy"],
        social: {
          discord: "https://discord.gg/xalonode"
        }
      },
      {
        id: "p2",
        name: "کاک ڕێبین (Rebin)",
        role: "هاوبەش و بەڕێوەبەری میدیا (Co-Founder & Media Lead)",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
        banner: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=800&q=80",
        bio: "بەخێربێن بۆ ماڵپەڕەکەمان! من سەرپەرشتیاری بەشەکانی فیلم، ئەنیمێ، کارتۆن و بەرنامەکانم. ئامانجمان ئەوەیە هەمیشە نوێترین ناوەڕۆکی جیهانی بە بەرزترین کوالێتی پێشکەش بکەین.",
        skills: ["Media Production", "Gaming Specialist", "Community Admin"],
        social: {
          discord: "https://discord.gg/xalonode"
        }
      }
    ]
  }
};
